import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'
import { colors } from '@styles/global/colors'

export const InstructorContainer = styled.div<{ altBg: string | undefined }>`
  padding: 40px 0 0;
  position: relative;
  z-index: 3;
  background: ${props => {
  return props.altBg ? props.altBg : props.theme.backgroundPrimary
}};
    overflow: hidden;
  @media ${device.tablet} {
    padding: 80px 0;
  }
`
export const InstructorImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  grid-column: 2 / 4;
  
  @media ${device.tablet}{
    margin-left: -30px;
    justify-content: flex-start;
    grid-column: 6 / 10;
  }
  
  @media ${device.laptop}{
    grid-column: 4 / 7;
    justify-content: center;
  }
`
export const InstructorInkStreak = styled.div`
  @media ${device.tablet}{
    display: block;
    top: 40px;
    position: absolute;
    left: 0;
    width: 100%;
    z-index: 1;
  }
  @media ${device.laptop}{
      top: 50%;
      transform: translateY(-50%);
  }
`
export const BioWrapper = styled.div`
  color: ${props => props.theme.textColor};
  padding: 0 20px 0 25px;
  grid-column: 2 / 4;
  
  h2{
    color: ${props => props.theme.headlineColor};
    font-weight: 600;
    margin: 20px 0;
  }
  p{
    font-size: 18px;
  }
  svg{
    transform: rotate(5deg);
    path{
      fill: ${colors.primary.pink};
    }
  }
  
  @media ${device.tablet}{
  padding: 0 20px;
  grid-column: 4 / 12;
  }
  
  @media ${device.laptop}{
    grid-column: 7 / 13;
  }
`
export const Profile = styled.div`
  width: 182px;
  height: 182px;
  border-radius: 50%;
  z-index: 2;
  position: relative;
  overflow: hidden;
`
export const SpacerBlock = styled.div`
  grid-row: 3;
  margin-bottom: 45px;
  
  @media ${device.tablet}{
    display: block;
    grid-column: 4/ 14;
    margin-bottom: 80px;  
  }
  
  @media ${device.laptop}{
    margin-bottom: 120px;  
  }
`
export const SpacerBlockTop = styled.div`
  display: none;
  @media ${device.tablet}{
    display: block;
    grid-row: 1;
    margin-top: 40px;  
  }
  
  @media ${device.laptop}{
      grid-column: 4/ 14;

    margin-top: 80px;  
  }
`
